import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app.tsx";
import { captureSessionFromUrlFragment } from "./auth.ts";

// Must run before React mounts. Child effects fire before parent effects, so
// auth-gated subtrees would otherwise read an empty localStorage and render
// the signed-out view before App's effect could capture the fragment.
captureSessionFromUrlFragment();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
